export enum ReactionUsageContextTypeEnum {
  Item = 'item',
  Manufacturer = 'manufacturer'
}
